import store from '@state/store'
import {max, min} from "moment";

export function toCelcius(value) {
  return ((value - 32) * (5 / 9)).toFixed(1)
}

export function convertTemperature(value, unitsMeasurementValue) {
  if (unitsMeasurementValue !== 'us') {
    return `${value} ℃`
  } else {
    const fahrenheit = value * (9 / 5) + 32
    return `${fahrenheit.toFixed(1)} ℉`
  }
}

export function convertBatteryCharge(value, mode, withoutValueSymbol) {
  if(!value && value !== 0)
    return value
  if (mode === 'volts') {
    return withoutValueSymbol ? value :  `${value} V`
  } else {
    let minBatteryVolts = store.state.globalSettings.settings['0BatteryChargeVolts'];
    let maxBatteryVolts = store.state.globalSettings.settings['100BatteryChargeVolts'];
    let result = (Math.min((Math.max(value, minBatteryVolts)-minBatteryVolts)/(maxBatteryVolts-minBatteryVolts), 1)*100).toFixed(1);
    return withoutValueSymbol ? result : `${result}%`
  }
}
